import RecordsUser from "./records-user";

/** Шапка таблицы записей */
const RecordsHeader = ({users, height, timeWidth, userWidth, records, vid, onResize, calendars }) => {

  const divHeader = [
    <div style={{width: timeWidth, height: height }} key={0}>Время</div>,
    ...users.map((item, index) => (
      <div key={item.id !== null ? item.id : `null-${index}`} style={{width: userWidth, height: height, position: 'relative'}}>
        <RecordsUser user={item} height={height} width={userWidth} qty={records.filter(i => vid === 0 ? (item.id === null ? i.userId === null : i.userId === item.id) : (item.id === null ? i.roomId === null : i.roomId === item.id)).length} vid={vid} calendars={calendars}/>
        {index > 0 && (
          <div 
            className="resize-handle"
            style={{
              position: 'absolute',
              right: -2,
              top: 0,
              bottom: 0,
              width: 4,
              cursor: 'col-resize',
              background: 'transparent',
              zIndex: 100
            }}
            onMouseDown={onResize}
          />
        )}
      </div>
    ))
  ]

  return<div className="records-header">
    {divHeader}
  </div>
}

export default RecordsHeader;